import React from 'react';
import { ThemeProvider as RestyleThemeProvider, useTheme as useRestyleTheme } from '@shopify/restyle';

import { createTheme } from './createTheme';
import type { ThemeSelection } from './types';
import type { Theme } from './restyle';

export interface DSThemeProviderProps {
  children?: React.ReactNode;
  selection?: Partial<ThemeSelection>;
}

export function ThemeProvider({ children, selection }: DSThemeProviderProps) {
  const theme = createTheme(selection);
  return <RestyleThemeProvider theme={theme}>{children}</RestyleThemeProvider>;
}

export function useTheme(): Theme {
  return useRestyleTheme<Theme>();
}
